import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar, A11y } from "swiper";

const MerchantDetail = () => {
  return (
    <div>
      <div className="row min-vh-100">
        <div className="container justify-content-center">
          <div className="py-4 d-flex justify-content-center align-items-center flex-column">
            <div className="d-flex position-relative mb-3 justify-content-center w-75">
              <h4 className="m-auto text-center">Merchants Details</h4>
            </div>

            <div className="w-100">
              {/* //create your ui here */}

              <div className="h-100">
                <div className="">
                  <div
                    className=" shadow rounded"
                    // style={{ borderRadius: "1rem" }}
                  >
                    <div className="card-body px-5 py-4 col-md-12">
                      <div className="row">
                        <div className="col-md-8">
                          <div className="">
                            <h5>Primary Details</h5>
                            <hr />

                            <div>
                              <span className="text-success fw-bold data-name">
                                Business Name
                              </span>
                              <span className="fw-bold">Vendor Name</span>
                            </div>

                            <div>
                              <span className="text-success fw-bold data-name">
                                Business Email
                              </span>
                              <span className="fw-bold">example@gmail.com</span>
                            </div>

                            <div>
                              <span className="text-success fw-bold data-name">
                                Business Mobile
                              </span>
                              <span className="fw-bold">example@gmail.com</span>
                            </div>

                            <div>
                              <span className="text-success fw-bold data-name">
                                Address
                              </span>
                              <span className="fw-bold">
                                Ward No: Division: Pincode:
                              </span>
                            </div>

                            <div>
                              <span className="text-success fw-bold data-name">
                                Owner Name
                              </span>
                              <span className="fw-bold"> Owner Name</span>
                            </div>

                            <div>
                              <span className="text-success fw-bold data-name">
                                Description
                              </span>
                              <span className="fw-bold">Description</span>
                            </div>
                            <hr />

                            <div>
                              <h5>Customise</h5>
                              <hr />
                            </div>

                            <div>
                              <div className="row">
                                <span className="col-md-3 text-success fw-bold data-name">
                                  Social Media Links
                                </span>
                                <span className="col-md-9 fw-bold">
                                  {/* <a href=""> me-2 text-white rounded-2 ' style={{ backgroundColor: "#3B5998" }} /></a>
                                    <a href=""><AiOutlineInstagram className='fs-3 me-2 text-white rounded-2' style={{ backgroundColor: " #bc2a8d" }} /></a>
                                    <a href=""><AiOutlineTwitter className='fs-3 me-2  text-white rounded-2' style={{ backgroundColor: " #55ACEE" }} /></a>
                                    <a href=""><AiOutlineYoutube className='fs-3 me-2  text-white rounded-2' style={{ backgroundColor: "#bb0000" }} /></a> */}
                                  {/* <p><AiFillFacebook className='fs-3 me-1'/>Facebook : <a href="https://www.facebook.com/mynashikmc/">https://www.facebook.com/mynashikmc/</a></p>
                                    <p><AiFillInstagram className='fs-3 me-1'/>Instagram : <a href="https://www.facebook.com/mynashikmc/">https://www.facebook.com/mynashikmc/</a></p>
                                    <p><AiFillTwitterSquare className='fs-3 me-1'/>Twitter : <a href="https://www.facebook.com/mynashikmc/">https://www.facebook.com/mynashikmc/</a></p>
                                    <p><AiFillYoutube className='fs-3 me-1'/>Linkedin : <a href="https://www.facebook.com/mynashikmc/">https://www.facebook.com/mynashikmc/</a></p> */}

                                  {/* {vendor.socialmedialinks.map((item, i) => {
                                    return (
                                      <p key={item.link}>
                                        {i + 1}
                                        {")"} {item.name}:{" "}
                                        <a href={item.link}>{item.link}</a>
                                      </p>
                                    );
                                  })} */}
                                </span>
                              </div>
                            </div>

                            <div className="mt-2 row">
                              <span className="col-md-3 text-success fw-bold data-name">
                                Opening Closing Time
                              </span>
                              <span className="fw-bold col-md-9">
                                4.00 am - 2.00 pm
                              </span>
                            </div>

                            <div>
                              <span className="mt-2 text-success fw-bold data-name">
                                Ratings
                              </span>
                              <span className=" fw-bold fs-4 "></span>
                            </div>

                            <div>
                              <p className="my-2 text-success fw-bold data-name">
                                Photos
                              </p>
                              <Swiper
                                slidesPerView={3}
                                modules={[Scrollbar, A11y]}
                                spaceBetween={10}
                                scrollbar={{ draggable: true }}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 10,
                                  },
                                }}
                                className="pb-3 row text-center"
                              >
                                <SwiperSlide>
                                  <img
                                    // src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg?size=626&ext=jpg&ga=GA1.1.1826414947.1699142400&semt=sph"
                                    alt="ecommercePhotos"
                                  />
                                </SwiperSlide>
                              </Swiper>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 ">
                          <img
                            className="img-fluid"
                            alt="img"
                            src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg?size=626&ext=jpg&ga=GA1.1.1826414947.1699142400&semt=sph"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* //end your ui here */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantDetail;
